import { Tooltip, WithToolTipProps } from 'components/Blocks';

import { truncateText } from 'utils/text';

interface TruncateTextProps extends Omit<WithToolTipProps, 'tooltipContent'> {
  text: string;
  max: number;
  className?: string;
}

export function TruncateText({ max, text, className, ...props }: TruncateTextProps) {
  return (
    <Tooltip content={text} disabled={props.tooltipDisabled ?? text.length <= max} {...props}>
      <span className={className}>{truncateText(text, max)}</span>
    </Tooltip>
  );
}
